import { Link } from "react-router-dom";
import s from "./guide.module.css";

const steps = (name, ranking, publicMode) => [
  { id: "courses", to: `/advanced?subject=${encodeURIComponent(name)}`, title: "Browse matching courses", text: `Find ${name} courses at individual universities that fit your grades, budget and countries.` },
  ranking && { id: "ranking", to: ranking, title: "See the UK subject ranking", text: `How UK universities compare for ${name}.` },
  { id: "chances", to: "/admission", title: "Check my chances", text: "Enter your grades and see where you stand for a course you like." },
  { id: "quiz", to: "/beta/course-fit", title: publicMode ? "Open Fast Match" : "Take the subject-fit quiz",
    text: publicMode ? "Carry on where you left off, or start a new match. Reading this guide never changes your answers." : "A short quiz that suggests subjects that suit you." },
  { id: "directory", to: "/subjects", title: "Explore other subject guides", text: "Every published guide, grouped by subject family." },
].filter(Boolean);

// End-of-guide next steps; unlocked once every section is finished, otherwise lists what is left.
export function WhatNext({ nav, done, go, name, ranking, publicMode = false }) {
  const left = nav.filter((t) => !done.has(t.id));
  if (left.length) {
    return (
      <aside className={s.nextLocked} data-testid="student-whatnext-locked">
        <p className={s.pagerCounter}>{nav.length - left.length} of {nav.length} sections finished</p>
        <p>Finish {left.length === 1 ? "this section" : "these sections"} to unlock your next steps:</p>
        <div className={s.actions}>
          {left.map((t) => (
            <button key={t.id} type="button" onClick={() => go(t.id)} data-testid={`student-whatnext-left-${t.id}`}>{t.label}</button>
          ))}
        </div>
      </aside>
    );
  }
  return (
    <aside className={s.whatNext} aria-labelledby="student-whatnext-title" data-testid="student-whatnext">
      <p className={s.pagerCounter}>Guide finished · {nav.length} of {nav.length}</p>
      <h3 id="student-whatnext-title" className={s.whatNextTitle}>What next for you and {name}?</h3>
      <div className={s.whatNextGrid}>
        {steps(name, ranking, publicMode).map((c) => (
          <Link key={c.id} to={c.to} className={s.whatNextCard} data-testid={`student-whatnext-${c.id}`}>
            <span className={s.whatNextCardTitle}>{c.title}<span aria-hidden="true" className={s.pagerArrow}>→</span></span>
            <span className={s.whatNextCardText}>{c.text}</span>
          </Link>
        ))}
      </div>
    </aside>
  );
}
